
/* eslint-disable @typescript-eslint/naming-convention */
import React, { useCallback, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Divider,
  Grid,
  TextField,
  Typography,
  Drawer,
} from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { pimApis } from 'src/api/pim';
import { useParams } from 'react-router';

const useStyles = makeStyles<any>(() =>
  createStyles({
    createFormSideBar: {
      width: '30%',
      border: 'none',
      '& .ticketBody': {
        height: '90vh',
        overflowY: 'auto',
        padding: '5px 20px',
        '& input': {
          borderRadius: '2px',
          padding: '8px',
        },
        '& .select': {
          minHeight: '22px !important',
          padding: '0 10px',
          lineHeight: '116.7%',
          color: '#696969',
          width: '100%',
          '& .MuiAutocomplete-input': {
            minHeight: '38px !important',
            padding: 0,
          },
        },
      },
      '& .dividerWrapper': {
        margin: '17px 0px 20px 0px '
      },
      '& .BoxText': {
        marginBottom: '20px',
        '& p': {
          margin: '0px'
        },
        '& .heading': {
          fontSize: '13px',
          color: '#425466',
          margin: '0px',
          fontWeight: '600'
        },
        '& .description': {
          fontSize: '14px',
          color: '#B5B5BD',
          margin: '0px',
          fontWeight: '600'
        }
      },
      '& h4': {
        background: '#C22027',
        color: '#fff',
        padding: '10px 40px',
        margin: '-5px -20px 30px',
        height: '64px',
        display: 'flex',
        alignItems: 'center',
      },
      '& label': {
        letterSpacing: ' 0.15px',
        color: '#231F20',
        fontWeight: '600',
        fontSize: '12px',
        display: 'block',
      },
      '&    .MuiDivider-root': {
        // paddingTop: '12px'
      },
      '& .CheckboxesSection': {
        marginTop: '25px',
        '& .MuiCheckbox-root': {
          padding: '0px 7px 0px 0px',
        },
        '& .MuiFormControlLabel-label': {
          fontSize: '13px',
          color: '#667085',
        },
        '& label': {
          margin: '0px 0px 0px 0px',
          top: '0px',
          backgroundColor: 'white',
          // padding: '2px',
        }

      },
      '& .selectField': {


        '& label': {
          top: '0px',
          backgroundColor: 'white',
          padding: '4px',
        },
      },
      '& .customFieldSection': {
        '& .customField': {
          paddingTop: '5px',
        },
        '& .MuiGrid-item': {
          '&:nth-child(1)': {
            paddingTop: '8px',
          },
        },

        '& .MuiSelect-select': {
          padding: '8px',
        },
        '& .addCustomFieldBT': {
          padding: '0px !important',
          backgroundColor: 'transparent',
          color: '#EE3235',
          boxShadow: 'none',
          fontSize: '12px',
          '&:hover': {
            backgroundColor: 'transparent',
          },
        },
      },

      // 


    },
    advancedFilter: {
      '& .fields+.fields': {
        marginTop: '15px',
      },
      '& .datefield': {
        position: 'relative',
        '& .rdrCalendarWrapper': {
          zIndex: '999',
          position: 'absolute',
          right: '-1px',
          borderRadius: '5px',
          border: '1px solid rgb(239, 242, 247)',
          '& .rdrDateDisplayWrapper': {
            borderTopLeftRadius: '5px',
            borderTopRightRadius: '5px',
          },
        },
      },
    },
    datePicker: {
      zIndex: '999',
      position: 'absolute',
      borderRadius: '5px',
    },
  })
);


const generateValidationSchema = (categoriesData) =>
  Yup.object().shape({
    // name: Yup.string()
    //   .required('Name is required')
    //   .min(2, 'Name must be at least 2 characters')
    //   .max(50, 'Name must not exceed 50 characters'),
    // description: Yup.string()
    //   .required('Description is required')
    //   .min(10, 'Description must be at least 10 characters')
    //   .max(500, 'Description must not exceed 500 characters'),
    productTemplateObject: Yup.array().of(
      Yup.object().shape({
        value: Yup.string().when('isMandatory', {
          is: true,
          then: Yup.string().required('This field is required'),
        }),
      })
    ),
  });


export default function CatagoryDrawer(props: any) {
  const {
    open,
    onClose,
    onSubmit,
    initialValues,
    title,
    editProduct,
    productFields,

    currentProduct
  } = props;
  const { categoryId, productTemplateId } = useParams();
  const classes = useStyles();
  const [categoriesData, setCategoriesData] = useState([]);
  const [cateFields, setCateFields] = useState({
    name: '',
    description: ''
  });



  const handleClose = () => {
    setCategoriesData(prevData =>
      prevData.length > 0
        ? prevData.map(item => ({ ...item, value: '' }))
        : []
    );
    onClose();
    setCateFields({
      name: '',
      description: '',
    });
  };




  useEffect(() => {
    if (currentProduct && Object.keys(currentProduct).length > 0) {
      const updatedCategories = productFields.map((field) => {
        const matchingKey = Object.keys(currentProduct).find(
          (key) => key.toLowerCase() === field.name.toLowerCase()
        );
        return {
          ...field,
          value: matchingKey ? currentProduct[matchingKey] : '', // Use the matching key
        };
      });
      setCategoriesData(updatedCategories);
    } else {
      setCategoriesData(productFields);
    }
  }, [currentProduct, productFields]);

  // console.log('currentProduct-1', currentProduct);
  // console.log('productFields-2', productFields);
  // console.log('categories Data-3', categoriesData);


  const validationSchema = React.useMemo(
    () => generateValidationSchema(categoriesData),
    [categoriesData]
  );

  const getFieldValue = (field: any) => {

    if (field.fieldType === "int") {
      const value = field.value ?? 0;

      if (field.isMandatory) {
        return value <= 0 ? 1 : Number(value);
      }

      return Number(value);
    }


    return field.value ?? "";
  };


  return (
    <Drawer
      title={title}
      open={open}
      onClose={handleClose}
      anchor="right"
      classes={{ paper: classes.createFormSideBar }}
      sx={{
        zIndex: 1300,
        '& .MuiDrawer-paper': {
          width: '40%', // Set the desired width here
        },
      }}

    >
      <Box className="ticketBody">
        <Typography variant="h4">{title}</Typography>

        {/* <Formik
          initialValues={{
            productTemplateObject: categoriesData.map((field) => ({
              value:
                // eslint-disable-next-line 
                field.fieldType === "int"
                  ? Number(field.value || 0)
                  : field.fieldType === "double"
                    ? parseFloat(field.value || "0").toFixed(1)
                    : field.value,
              isMandatory: field.isMandatory || false,
              name: field.name,
            })),
          }}
          validationSchema={validationSchema}
          onSubmit={async (values) => {
            console.log('values', values)


            const productTemplateObject = values.productTemplateObject.reduce(
              (acc, obj) => {
                const { value, name, isMandatory } = obj;

                // eslint-disable-next-line 
                if (typeof value === "string" && !isNaN(parseFloat(value))) {
                  const numValue = parseFloat(value);

                  acc[name] = Math.round(numValue * 10) / 10;
                } else {
                  acc[name] = value;
                }

                return acc;
              },
              {}
            );

            const payload: any = {
              productTemplateObject: {
                ...productTemplateObject,
              },
            };

            // Add categoryId and isActive if currentProduct length is 0
            if (!currentProduct || Object.keys(currentProduct).length === 0) {
              payload.categoryId = categoryId;
              payload.isActive = true;
            }



            await onSubmit(payload);
            handleClose();
          }}
          enableReinitialize
        > */}


        <Formik
          initialValues={{
            productTemplateObject: categoriesData.map((field) => ({
              value:
                // eslint-disable-next-line
                field.fieldType === "int"
                  ? Number(field.value || 0)
                  : field.fieldType === "double"
                    ? parseFloat(field.value || "0").toFixed(1)
                    : field.value,
              isMandatory: field.isMandatory || false,
              name: field.name,
              fieldType: field.fieldType, // Add this line
            })),
          }}
          validationSchema={validationSchema}
          onSubmit={async (values) => {
            const productTemplateObject = values.productTemplateObject.reduce(
              (acc, obj) => {
                const { value, name, isMandatory, fieldType } = obj;

                // Only apply decimal handling to double type fields
                // eslint-disable-next-line 
                if (fieldType === "double" && typeof value === "string" && !isNaN(parseFloat(value))) {
                  const numValue = parseFloat(value);
                  acc[name] = Math.round(numValue * 10) / 10;
                  // eslint-disable-next-line
                } else if (fieldType === "int" && typeof value === "string" && !isNaN(parseInt(value))) {
                  // eslint-disable-next-line
                  acc[name] = parseInt(value);
                } else {
                  acc[name] = value;
                }

                return acc;
              },
              {}
            );
            const payload: any = {
              productTemplateObject: {
                ...productTemplateObject,
              },
            };

            // Add categoryId and isActive if currentProduct length is 0
            if (!currentProduct || Object.keys(currentProduct).length === 0) {
              payload.categoryId = categoryId;
              payload.isActive = true;
            }

            console.log('payload', payload)


            await onSubmit(payload);
            handleClose();
          }}
          enableReinitialize
        >

          {({ handleSubmit, errors, touched, setFieldValue }) => (
            <Form onSubmit={handleSubmit}>



              {categoriesData.length > 0 && (
                <Box className='CheckboxesSection'>
                  <Box className='BoxText'>
                    {/* <p className="heading"></p> */}
                    {/* <p className="description">Select options that are applicable </p> */}
                  </Box>
                  <Grid container spacing={2}>
                    {categoriesData.map((field, index) => (
                      <Grid item xs={12} key={field.name}>

                        <Field name={`productTemplateObject[${index}].value`}>
                          {({ field: formField }) => (
                            <TextField
                              {...formField}
                              label={
                                <span>
                                  {field.name}{" "}
                                  {field.isMandatory && <span style={{ color: "red" }}>*</span>}
                                </span>
                              }
                              fullWidth
                              onChange={(e) => {
                                let newValue = e.target.value;

                                if (field.fieldType === "int" && /\./.test(newValue)) {
                                  return; // Prevent decimals in integer fields
                                }
                                if (field.fieldType === "double") {
                                  // eslint-disable-next-line 
                                  if (!isNaN(parseFloat(newValue))) {
                                    // Round to exactly one decimal place to avoid floating point issues
                                    const numValue = parseFloat(newValue);
                                    const roundedValue = Math.round(numValue * 10) / 10;
                                    newValue = roundedValue.toString();
                                  }
                                }
                                setCategoriesData((prev) =>
                                  prev.map((item, idx) =>
                                    idx === index ? { ...item, value: newValue } : item
                                  )
                                );
                                setFieldValue(`productTemplateObject[${index}].value`, newValue);
                              }}
                              value={
                                field.fieldType === "int" || (field.fieldType === "double")
                                  ? categoriesData[index]?.value || 0
                                  : categoriesData[index]?.value || ""
                              }
                              inputProps={{
                                type:
                                  // eslint-disable-next-line 
                                  field.fieldType === "email"
                                    ? "email"
                                    // eslint-disable-next-line 
                                    : field.fieldType === "int"
                                      ? "number"
                                      : field.fieldType === "double"
                                        ? "number"
                                        : "text",
                                step: field.fieldType === "double" ? "any" : undefined,
                                min:
                                  // eslint-disable-next-line 
                                  field.fieldType === "double"
                                    ? 0.0
                                    : field.fieldType === "int"
                                      ? 0
                                      : 0,
                              }}

                              error={
                                touched.productTemplateObject?.[index]?.value &&
                                Boolean((errors.productTemplateObject?.[index] as any)?.value)
                              }
                              helperText={
                                touched.productTemplateObject?.[index]?.value &&
                                (errors.productTemplateObject?.[index] as any)?.value
                              }
                            />
                          )}
                        </Field>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              )}
              <Box sx={{ display: 'flex', justifyContent: 'flex-start', marginTop: 5 }}>
                <Button
                  type="button"
                  variant="outlined"
                  color="secondary"
                  onClick={handleClose}
                  sx={{ marginRight: 1 }}
                >
                  Cancel
                </Button>
                <Button type="submit" variant="contained" color="secondary">
                  Done
                </Button>
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
    </Drawer>
  );
}
